export const SITE_URL = "https://www.meetkalani.com";
export const SITE_NAME = "Kalani Luana";

export const SEO_PAGES = [
  { key: "home", path: "/", label: "Home",
    title: "Kalani Luana — Luxury Companion & Adult Film Star | NYC, NJ & California",
    description: "Kalani Luana — adult film starlet and elite luxury companion in NYC/NJ and California, available for travel. Her story, portfolio and booking etiquette." },
  { key: "about", path: "/about", label: "About",
    title: "About Kalani Luana — Elite Companion in New York & California",
    description: "Meet Kalani Luana: adult film actress and luxury companion. Her philosophy, what to expect, personal details and fifteen fun facts." },
  { key: "gallery", path: "/gallery", label: "Gallery", noindex: true,
    title: "Gallery — Kalani Luana Portfolio",
    description: "Portraits, lifestyle photos and features of adult film star and luxury companion Kalani Luana." },
  { key: "booking-etiquette", path: "/booking-etiquette", label: "Booking Etiquette",
    title: "Booking Etiquette & Screening — Kalani Luana",
    description: "How to arrange time with Kalani Luana: screening requirements, arrangement types, donations and etiquette for a seamless first meeting." },
  { key: "booking", path: "/booking", label: "Booking Inquiry",
    title: "Request an Introduction — Book Kalani Luana",
    description: "Submit a discreet booking inquiry to meet luxury companion Kalani Luana in NYC, New Jersey, California or your city." },
  { key: "tour", path: "/tour", label: "Tour Schedule",
    title: "Tour Schedule — Where Kalani Luana Is Visiting Next",
    description: "Upcoming tour dates and cities for luxury companion Kalani Luana. Book ahead for her next visit." },
  { key: "travel", path: "/travel", label: "Exclusive Travel", noindex: true,
    title: "Exclusive Travel Companion — Kalani Luana",
    description: "Fly-me-to-you and extended travel arrangements with Kalani Luana." },
  { key: "gifts", path: "/gifts", label: "Spoil Me",
    title: "Spoil Me — Wishlist & Favorite Things | Kalani Luana",
    description: "Kalani Luana's favorite activities, gift ideas, sizes and wishlists." },
  { key: "faq", path: "/faq", label: "Q&A / FAQ",
    title: "Frequently Asked Questions — Kalani Luana",
    description: "Answers to common questions about booking, screening, etiquette and meeting Kalani Luana." },
  { key: "blog", path: "/blog", label: "Blog",
    title: "Blog — Musings from Kalani Luana",
    description: "Thoughts on connection, travel, luxury and life from adult film star and companion Kalani Luana." },
  { key: "contact", path: "/contact", label: "Contact",
    title: "Contact Kalani Luana",
    description: "Reach Kalani Luana by text, email or social media. Text is the preferred method of contact." },
  { key: "links", path: "/links", label: "Links",
    title: "Official Links — Kalani Luana",
    description: "Kalani Luana's only official profiles, platforms and verified links." },
];

export const pageForPath = (pathname) =>
  SEO_PAGES.find((p) => p.path === pathname) || (pathname.startsWith("/blog/") ? SEO_PAGES.find((p) => p.key === "blog") : null);

// Merge defaults with admin-edited values stored in content keys seo.page.<key> / seo.site
export const resolveSeo = (page, content) => {
  const edited = content[`seo.page.${page.key}`]?.metadata || {};
  const site = content["seo.site"]?.metadata || {};
  return {
    title: edited.title || page.title,
    description: edited.description || page.description,
    noindex: edited.noindex ?? !!page.noindex,
    canonical: `${SITE_URL}${page.path === "/" ? "/" : page.path}`,
    ogImage: edited.og_image || site.og_image || "",
    siteName: site.name || SITE_NAME,
    twitter: site.twitter || "",
    googleVerification: site.google_verification || "",
  };
};
